import { HealthcareProviderCreateZD3ReportStatisticsCommand } from '@dreryk/egabinet-statistics-frontend-api';

import { useCqrsCommand } from '@dreryk/command-query-react-common';
import { ModalConfirmButton } from '@dreryk/react-components';

import { statisticsTranslationKeys } from '../../../translations';
import { GenerateZD3FormBean, GenerateZD3FormController } from '../GenerateZD3Form.types';

export type GenerateStatisticsModalConfirmButtonProps = Pick<GenerateZD3FormController, 'handleSubmit'> & {
   readonly onSuccess: VoidFunction;
};

export const GenerateZD3StatisticsButton = (props: GenerateStatisticsModalConfirmButtonProps): JSX.Element => {
   const { executeAsync: createStatistics } = useCqrsCommand<void, GenerateZD3FormBean>(
      (parameters) => {
         const command = new HealthcareProviderCreateZD3ReportStatisticsCommand();
         command.healthcareFacilityUnitId = parameters.healthcareFacilityUnit!.id;
         command.includeVisitsFinishedNotApproved = parameters.includeVisitsFinishedNotApproved;
         command.includeVisitsInProgress = parameters.includeVisitsInProgress;
         command.year = parameters.year;
         return command;
      },
      {
         onSuccess: () => {
            props.onSuccess();
         },
      }
   );

   return (
      <ModalConfirmButton
         label={statisticsTranslationKeys.modal.submit}
         onClick={props.handleSubmit(createStatistics)}
      />
   );
};
